// Copy link URL to clipboard
// https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
document.querySelectorAll('[data-copy-url]').forEach((el) => {
  if (!el) {
    console.warn(`Unable to initialize copy URL functionality, no matching element for “${this.el}”`);
    return false;
  }

  // Store original link text
  const linkText = el.getAttribute('aria-label');

  // Set role="button" since the link will no longer function as a link
  el.setAttribute('role', 'button');

  // Add aria-live="assertive" so screenreaders announce immediately when the link has been copied
  el.setAttribute('aria-live', 'assertive');

  el.addEventListener('click', (evt) => {
    evt.preventDefault();

    navigator.clipboard.writeText(el.href).then(
      // Success
      () => {
        el.classList.add('copied');
        el.setAttribute('aria-label', 'Copied.');
        // Remove class after a short delay
        setTimeout(() => {
          el.classList.remove('copied');
          el.setAttribute('aria-label', linkText);
        }, 1500);
      },
      // Fail
      () => {
        el.classList.remove('copied');
      }
    );
  });
});
